import env, { clientId } from "../../../../env";
import { AppClientId } from "../../../Shared/constants";

let client_name = ''

{env.clientId === AppClientId.INDEWAL && (
  client_name = 'In de Wal Auto’s B.V'
)}
{env.clientId === AppClientId.IDWLEASE && (
  client_name = 'IDW Lease B.V.'
)}
{env.clientId === AppClientId.AUTOHUISSALLAND && (
  client_name = 'Autohuis Salland'
)}
{env.clientId === AppClientId.AUTOWIENTJES && (
  client_name = 'Auto Wientjes B.V.'
)}

export const LANG = {
  en: {
    purchase_agreement: 'Purchase agreement',
    purchase_agreement_subtitle: 'Subtitle',
    delivery_date: 'Delivery date',
    period: 'Period',
    consumer_data: 'Consumer data',
    relation_number: 'Relation number',
    name: 'Name',
    company_name: 'Relation Name',
    addressLine1: 'Address line 1',
    postcodeAndPlace: 'Postcode and Place',
    phone_number: 'Phone Number',
    company_email: 'Company email',
    email: 'Email',
    vehicle_data: 'Vehicle data',
    brand_name: 'Brand name',
    model_name: 'Model name',
    vin: 'VIN',
    date_first_allowance: 'Date first allowance',
    mileage: 'Mileage',
    garantie: 'Garantie',
    nap: 'NAP',
    logical: 'Logical',
    illogical: 'Illogical',
    no: 'No',
    yes: 'Yes',
    remaining_appointments: 'Remaining appointments',
    model_info: 'Model info',
    fuel_type: 'Fuel type',
    regplate: 'Regplate',
    base_color: 'Base color',
    passenger: 'Passenger',
    commercial: 'Commercial',
    details_of_trade_in: 'Details of purchased vehicle or other item (trade-in vehicles)',
    last_4_digits_vin: 'Last 4 digits VIN',
    date_apk_expiry: 'Date apk expiry',
    technical_state: 'Technical state',
    good: 'Good',
    injury: 'Injury',
    yes_taxatierapport: 'Yes (tax report)',
    financial_purchase_price_incl_vat_bpm: 'Price incl. VAT, BPM',
    initial_block: 'Initial block',
    vat_statement: 'Vat statement',
    buyier_declaration:
      'The buyer hereby declares that he/she has not claimed any input tax deduction for the vehicle/item purchased by the seller as described above and is not liable for any VAT related to the delivery to the buyer. The buyer also declares that the sold goods are not of stolen or fraudulent origin and/or are not claimed by third parties.',
    initials: 'Initials',
    price_to_deliver: 'Price to deliver',
    marge: 'Marge',
    btw: 'BTW',
    delivery_package: 'Delivery package',
    apk: 'APK',
    maintenance: 'Maintenance',
    distribution: 'Distribution',
    tyres: 'Tyres',
    to_polish: 'To polish',
    restyling: 'Restyling',
    towbar_7P_14P: 'towbar 7P/14P',
    autotrust_warranty: 'Autotrust warranty',
    obligated_to_charge: 'Due to government measures, we are obligated to charge the following: ',
    registration_payment: 'Vehicle registration payment',
    date: 'Date',
    buyer_signature: "Buyer's signature",
    name_seller_signature: 'Name/Seller Signature',
    subtotal_incl_bpm_vat: 'Subtotal (incl. BPM/VAT)',
    af_purchase_price: 'AF: Purchase price',
    total_paid_before_delivery: 'Total to be paid before delivery',
    deposit: 'Deposit',
    garantie: 'Garantie',
    garantie_n_v_t: 'Garantie n.v.t.; koper zietaf van BOVAG- garantie',
    mileage_history: 'Mileage history',
    mileage_history_is_accepted_as_illogical: 'Mileage history is accepted as illogical by the buyer.',
  },

  nl: {
    purchase_agreement: 'Koopovereenkomst',
    purchase_agreement_subtitle:
      'Ondergetekende bevestigt hiermede te hebben gekocht van '+client_name+', behoudens goedkeuring directie het voertuig:',
    delivery_date: 'Afleveringsdatum',
    period: 'Tijd',
    consumer_data: 'Gegevens consument',
    relation_number: 'Relatienummer',
    name: 'Naam',
    company_name: 'Relatie Naam',
    addressLine1: 'Adres',
    postcodeAndPlace: 'Postcode en plaats',
    phone_number: 'Telefoonnummer',
    company_email: 'Relatie E-mail',
    email: 'E-mail',
    vehicle_data: 'Gegevens verkocht voertuig (Consument verklaart hierbij van verkoper te hebben gekocht)',
    brand_name: 'Merk',
    model_name: 'Uitvoering',
    vin: 'Chassisnummer',
    date_first_allowance: 'Datum afgifte deel 1',
    mileage: 'Tellerstand',
    garantie: 'Garantie',
    nap: 'NAP',
    logical: 'Logisch',
    illogical: 'Onlogisch',
    no: 'nee',
    yes: 'ja',
    remaining_appointments: 'Overige afspraken',
    model_info: 'Type',
    fuel_type: 'Brandstof',
    regplate: 'Kenteken',
    base_color: 'Kleur',
    passenger: 'Personenauto',
    commercial: 'Bedrijfswagen',
    details_of_trade_in: 'Gegevens ingekocht voertuig of andere zaak ',
    last_4_digits_vin: 'Meldcode',
    date_apk_expiry: 'APK geldig tot',
    technical_state: 'Technische staat',
    good: 'goed',
    injury: 'Schade',
    yes_taxatierapport: 'Ja (taxatierapport)',
    financial_purchase_price_incl_vat_bpm: 'Inkoopprijs (incl. rest-bpm, incl. btw)',
    initial_block: 'Paraafblok',
    vat_statement: 'BTW verklaring',
    buyier_declaration:
      'Koper verklaart hierbij dat hij/zij voor de hierboven beschreven, door verkoper ingekochte voertuig/zaak, in het geheel géén voor-aftrek BTW heeft genoten en in verband met de levering aan koper geen BTW verschuldigd is. Tevens verklaart koper dat de verkochte goederen niet van diefstal of oneerlijke handelingen afkomstig zijn en/of door derden opeisbaar zijn. ',
    initials: 'Paraaf koper',
    price_to_deliver: 'Prijs te leveren auto',
    marge: 'Marge',
    btw: 'BTW',
    delivery_package: 'Afleveringspakket',
    apk: 'APK geldig tot',
    maintenance: 'Onderhoudsbeurt',
    distribution: 'Distributie',
    tyres: 'Banden',
    to_polish: 'To Poetsen',
    restyling: 'Restylen',
    towbar_7P_14P: 'Trekhaak 7P/14P',
    autotrust_warranty: 'garantie / AutoTrust',
    obligated_to_charge: 'Ingevolge overheidsmaatregelen zijn wij verplicht het navolgende in rekening te brengen:',
    registration_payment: 'Afdracht tenaamstelling voertuig',
    date: 'Datum',
    buyer_signature: 'Handtekening koper',
    name_seller_signature: 'Naam/Handtekening verkoper',
    subtotal_incl_bpm_vat: 'Subtotaal (incl. BPM/VAT)',
    af_purchase_price: 'AF: Inkoopprijs',
    total_paid_before_delivery: 'Totaal te voldoen vóór aflevering',
    deposit: 'Aanbetaling',
    garantie: 'Garantie',
    garantie_n_v_t: 'Garantie n.v.t.; koper ziet af van BOVAG-garantie',
    mileage_history: 'Kilometerhistorie',
    mileage_history_is_accepted_as_illogical: 'Kilometerhistorie is als zijnde onlogisch geaccepteerd door koper. ',
  },

  pl: {
    purchase_agreement: 'Umowa kupna-sprzedaży',
    purchase_agreement_subtitle:
      'Niniejszym podpisany potwierdza zakup pojazdu od '+client_name+', z zastrzeżeniem zgody zarządu:',
    delivery_date: 'Data dostawy',
    period: 'Czas',
    consumer_data: 'Dane klienta',
    relation_number: 'Numer klienta',
    name: 'Nazwa',
    company_name: 'Nazwa klienta',
    addressLine1: 'Adres',
    postcodeAndPlace: 'Kod pocztowy i miejscowość',
    phone_number: 'Numer telefonu',
    company_email: 'Adres e-mail',
    email: 'e-mail',
    vehicle_data: 'Dane sprzedanego pojazdu (Klient niniejszym oświadcza, że kupił pojazd od sprzedawcy)',
    brand_name: 'Marka',
    model_name: 'Wykonanie',
    vin: 'Numer podwozia',
    date_first_allowance: 'Data pierwszej dopłaty',
    mileage: 'Przebieg',
    garantie: 'Gwarancja',
    nap: 'NAP',
    logical: 'Logiczne',
    illogical: 'Nie logiczne',
    no: 'Nie',
    yes: 'Tak',
    remaining_appointments: 'Inne umowy',
    model_info: 'Typ',
    fuel_type: 'Paliwo',
    regplate: 'Numer rejestracyjny',
    base_color: 'Kolor',
    passenger: 'Samochód osobowy',
    commercial: 'Pojazd użytkowy',
    details_of_trade_in: 'Dane zakupionego pojazdu lub innych przedmiotów',
    last_4_digits_vin: 'Kod meldunkowy',
    date_apk_expiry: 'Ważne badanie techniczne (HU)',
    technical_state: 'Stan techniczny',
    good: 'Dobry',
    injury: 'Uszkodzenia',
    yes_taxatierapport: 'Tak (Ekspertyza)',
    financial_purchase_price_incl_vat_bpm: 'Cena zakupu (w tym pozostała kwota BPM, w tym podatek VAT)',
    initial_block: 'Blok podpisów',
    vat_statement: 'Oświadczenie VAT',
    buyier_declaration:
      'Kupujący niniejszym oświadcza, że nie skorzystał z podatku VAT odliczalnego w odniesieniu do powyższego pojazdu/obiektu kupionego od sprzedawcy i nie jest zobowiązany do zapłaty podatku VAT w związku z dostawą do kupującego. Kupujący oświadcza również, że sprzedawane towary nie pochodzą z kradzieży lub nieuczciwych działań i/lub nie mogą być żądane przez osoby trzecie.',
    initials: 'Podpis kupującego',
    price_to_deliver: 'Cena pojazdu do dostarczenia',
    marge: 'Marża',
    btw: 'Podatek VAT',
    delivery_package: 'Pakiet dostawy',
    apk: 'Ważne badanie techniczne (HU) do',
    maintenance: 'Konserwacja',
    distribution: 'Rozdział',
    tyres: 'Opony',
    to_polish: 'Polerowanie',
    restyling: 'Restylizacja',
    towbar_7P_14P: 'Hak holowniczy 7P/14P',
    autotrust_warranty: 'Gwarancja / AutoTrust',
    obligated_to_charge: 'Zgodnie z przepisami rządowymi jesteśmy zobowiązani do doliczenia następujących kosztów:',
    registration_payment: 'Przekazanie pojazdu na imię kupującego',
    date: 'Data',
    buyer_signature: 'Podpis kupującego',
    name_seller_signature: 'Nazwa/Podpis sprzedawcy',
    subtotal_incl_bpm_vat: 'Suma (w tym BPM/VAT)',
    af_purchase_price: 'ODLICZENIE: Cena zakupu',
    total_paid_before_delivery: 'Całkowita kwota do zapłaty przed dostawą',
    deposit: 'Zaliczka',
    garantie: 'Gwarancja',
    garantie_n_v_t: 'Brak gwarancji; Kupujący rezygnuje z gwarancji BOVAG',
    mileage_history: 'Historia kilometrów',
    mileage_history_is_accepted_as_illogical: 'Historia kilometrów została zaakceptowana przez kupującego jako nielogiczna.',
  },

  de: {
    purchase_agreement: 'Kaufvertrag',
    purchase_agreement_subtitle:
      'Der Unterzeichnete bestätigt hiermit den Kauf des Fahrzeugs von '+clientId+', vorbehaltlich der Zustimmung der Geschäftsführung:',
    delivery_date: 'Lieferdatum',
    period: 'Zeit',
    consumer_data: 'Kundendaten',
    relation_number: 'Kundennummer',
    name: 'Name',
    company_namename: 'Kunder Name',
    addressLine1: 'Adresse',
    postcodeAndPlace: 'Postleitzahl und Wohnort',
    phone_number: 'Telefonnummer',
    company_email: 'E-mail',
    email: 'Kunder E-mail',
    vehicle_data: 'Daten des verkauften Fahrzeugs (Der Kunde erklärt hiermit, das Fahrzeug vom Verkäufer gekauft zu haben)',
    brand_name: 'Marke',
    model_name: 'Ausführung',
    vin: 'Fahrgestellnummer',
    date_first_allowance: 'Datum der ersten Zulage',
    mileage: '',
    garantie: 'Garantie',
    nap: 'NAP',
    logical: 'Logisch',
    illogical: 'Unlogisch',
    no: 'Nein',
    yes: 'Ja',
    remaining_appointments: 'Weitere Vereinbarungen',
    model_info: 'Typ',
    fuel_type: 'Kraftstoff',
    regplate: 'Kennzeichen',
    base_color: 'Farbe',
    passenger: 'Personenwagen',
    commercial: 'Nutzfahrzeug',
    details_of_trade_in: 'Daten des gekauften Fahrzeugs oder anderer Gegenstände',
    last_4_digits_vin: 'Meldcode',
    date_apk_expiry: 'Gültige Hauptuntersuchung (HU)',
    technical_state: 'Technischer Zustand',
    good: 'Gut',
    injury: 'Beschädigung',
    yes_taxatierapport: 'Ja (Gutachten)',
    financial_purchase_price_incl_vat_bpm: 'Kaufpreis (einschließlich Rest-BPM, einschließlich MwSt.)',
    initial_block: 'Unterschriftenblock',
    vat_statement: 'MwSt.-Erklärung',
    buyier_declaration:
      'Der Käufer erklärt hiermit, dass er für das oben beschriebene, vom Verkäufer gekaufte Fahrzeug/Objekt keine Vorsteuer-BTW in Anspruch genommen hat und aufgrund der Lieferung an den Käufer keine Mehrwertsteuer geschuldet wird. Der Käufer erklärt auch, dass die verkauften Waren nicht aus Diebstahl oder unlauteren Handlungen stammen und/oder von Dritten eingefordert werden können.',
    initials: 'Unterschrift des Käufers',
    price_to_deliver: 'Preis des zu liefernden Autos',
    marge: 'Marge',
    btw: 'MwSt.',
    delivery_package: 'Lieferungspaket',
    apk: 'Gültige Hauptuntersuchung (HU) bis',
    maintenance: 'Wartung',
    distribution: 'Verteilung',
    tyres: 'Reifen',
    to_polish: 'Polieren',
    restyling: 'Restyling',
    towbar_7P_14P: 'Anhängerkupplung 7P/14P',
    autotrust_warranty: 'Garantie / AutoTrust',
    obligated_to_charge: 'Aufgrund von Regierungsmaßnahmen sind wir verpflichtet, folgende Kosten in Rechnung zu stellen',
    registration_payment: 'Übertragung des Fahrzeugs auf den Namen des Käufers',
    date: 'Datum',
    buyer_signature: 'Unterschrift des Käufers',
    name_seller_signature: 'Name/Unterschrift des Verkäufers',
    subtotal_incl_bpm_vat: 'Zwischensumme (inkl. BPM/MwSt.)',
    af_purchase_price: 'ABZÜGLICH: Einkaufspreis',
    total_paid_before_delivery: 'Gesamtbetrag fällig vor der Lieferung',
    deposit: 'Anzahlung',
    garantie: 'Garantie',
    garantie_n_v_t: 'Garantie nicht verfügbar; Käufer verzichtet auf BOVAG-Garantie',
    mileage_history: 'Kilometerhistorie',
    mileage_history_is_accepted_as_illogical: 'Die Kilometerhistorie wurde vom Käufer als unplausibel akzeptiert.',
  },
};
